import { render, staticRenderFns } from "./RoomPicker.vue?vue&type=template&id=45008ded&scoped=true&"
import script from "./RoomPicker.vue?vue&type=script&lang=ts&"
export * from "./RoomPicker.vue?vue&type=script&lang=ts&"
import style0 from "./RoomPicker.vue?vue&type=style&index=0&id=45008ded&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45008ded",
  null
  
)

export default component.exports